import {useSelector} from "react-redux";
import {getUrl} from "../../../constants/urls";
import {getCurrentCustomer} from "../../../redux/Selectors/customers.selectors";
import {
  getCurrentSite,
  getSelectedLocations,
} from "../../../redux/Selectors/sites.selectors";

export const useGetControllerListUrl = () => {
  const currentCustomer = useSelector(getCurrentCustomer);
  const currentSite = useSelector(getCurrentSite);
  const currentLocation = useSelector(getSelectedLocations);

  const controllerListURL = getUrl("controllers_new_list")(
    currentCustomer.id,
    currentSite.id,
    currentLocation.id
  );
  return {controllerListURL};
};
